// Import is already correct, no changes needed
import {
  AddPageButton,
  // AppDownloadButton,
  AppSidebar,
  MenuItem,
  MenuLinkItem,
  QuickSearchInput,
  SidebarContainer,
  SidebarScrollableContainer,
} from '@affine/core/modules/app-sidebar/views';
// import { ExternalMenuLinkItem } from '@affine/core/modules/app-sidebar/views/menu-item/external-menu-link-item';
import { AuthService } from '@affine/core/modules/cloud';
import { WorkspaceDialogService } from '@affine/core/modules/dialogs';
import { CMDKQuickSearchService } from '@affine/core/modules/quicksearch/services/cmdk';
import {
  WorkspaceService,
  type Workspace,
} from '@affine/core/modules/workspace';
import { useI18n } from '@affine/i18n';
import { track } from '@affine/track';
import type { Store } from '@blocksuite/affine/store';
import {
  // AiOutlineIcon,
  AllDocsIcon,
  ImportIcon,
  // JournalIcon,
  // SettingsIcon,
} from '@blocksuite/icons/rc';
import { useLiveData, useService, useServices } from '@toeverything/infra';
import type { ReactElement } from 'react';
import { memo, useCallback } from 'react';

import {
  CollapsibleSection,
  // NavigationPanelFavorites,
  // NavigationPanelMigrationFavorites,
  // NavigationPanelCollections,
  // NavigationPanelFavorites,
  // NavigationPanelMigrationFavorites,
  NavigationPanelOrganize,
  // NavigationPanelTags,
} from '../../desktop/components/navigation-panel';
import { WorkbenchService } from '../../modules/workbench';
// import { WorkspaceNavigator } from '../workspace-selector';
import {
  homeIcon,
  homeButton,
  // bottomContainer,
  quickSearch,
  quickSearchAndNewPage,
  // workspaceAndUserWrapper,
  // workspaceWrapper,
} from './index.css';
// import { InviteMembersButton } from './invite-members-button';
// import { AppSidebarJournalButton } from './journal-button';
// import { NotificationButton } from './notification-button';
// import { SidebarAudioPlayer } from './sidebar-audio-player';
// import { TemplateDocEntrance } from './template-doc-entrance';
import { TrashButton } from './trash-button';
// import { UpdaterButton } from './updater-button';
import UserInfo from './user-info';
import IconFont from '@ys/repo-ui/base/IconFont';

export type RootAppSidebarProps = {
  isPublicWorkspace: boolean;
  onOpenQuickSearchModal: () => void;
  onOpenSettingModal: () => void;
  currentWorkspace: Workspace;
  openPage: (pageId: string) => void;
  createPage: () => Store;
  paths: {
    all: (workspaceId: string) => string;
    trash: (workspaceId: string) => string;
    shared: (workspaceId: string) => string;
  };
};

const AllDocsButton = () => {
  const t = useI18n();
  const { workbenchService } = useServices({
    WorkbenchService,
  });
  const workbench = workbenchService.workbench;
  const allPageActive = useLiveData(
    workbench.location$.selector(location => location.pathname === '/all')
  );

  return (
    <MenuLinkItem icon={<AllDocsIcon />} active={allPageActive} to={'/all'}>
      <span data-testid="all-pages">
        {t['com.affine.workspaceSubPath.all']()}
      </span>
    </MenuLinkItem>
  );
};
const HomePageButton = () => {
  const t = useI18n();
  const { workbenchService, workspaceService } = useServices({
    WorkbenchService,
    WorkspaceService,
  });
  const workbench = workbenchService.workbench;
  const allPageActive = useLiveData(
    workbench.location$.selector(location => location.pathname === '/home')
  );

  const handleOpenHome = () => {
    workbench.openDoc('home');
    workspaceService.workspace.eventBus.emit(
      { id: 'chat.created', _type: 'chat.created' },
      {}
    );
  };

  //   <MenuItem
  //   data-testid="slider-bar-import-button"
  //   icon={<ImportIcon />}
  //   onClick={onOpenImportModal}
  // >
  //   <span data-testid="ismport-modal-trigger">{t['Import']()}</span>
  // </MenuItem>

  return (
    <MenuItem
      icon={<IconFont name="home" className={homeIcon} />}
      // active={allPageActive}
      onClick={() => {
        // workbench.openDoc('home');
        handleOpenHome();
      }}
      data-testid="home-button"
      className={homeButton}
    >
      <span data-testid="home">{t['com.affine.workspaceSubPath.home']()}</span>
    </MenuItem>
  );
};

// const AIChatButton = () => {
//   const { workbenchService } = useServices({
//     WorkbenchService,
//   });
//   const workbench = workbenchService.workbench;
//   const aiChatActive = useLiveData(
//     workbench.location$.selector(location => location.pathname === '/chat')
//   );

//   return (
//     <MenuLinkItem icon={<AiOutlineIcon />} active={aiChatActive} to={'/chat'}>
//       <span data-testid="ai-chat">Intelligence</span>
//     </MenuLinkItem>
//   );
// };

/**
 * This is for the whole affine app sidebar.
 * This component wraps the app sidebar in `@affine/component` with logic and data.
 *
 */
export const RootAppSidebar = memo((): ReactElement => {
  const { workbenchService, cMDKQuickSearchService } = useServices({
    WorkbenchService,
    CMDKQuickSearchService,
    AuthService,
  });

  // const sessionStatus = useLiveData(authService.session.status$);
  const t = useI18n();
  const workspaceDialogService = useService(WorkspaceDialogService);
  const workbench = workbenchService.workbench;

  // const workspaceSelectorOpen = useLiveData(workbench.workspaceSelectorOpen$);
  const onOpenQuickSearchModal = useCallback(() => {
    cMDKQuickSearchService.toggle();
  }, [cMDKQuickSearchService]);

  // const onWorkspaceSelectorOpenChange = useCallback(
  //   (open: boolean) => {
  //     workbench.setWorkspaceSelectorOpen(open);
  //   },
  //   [workbench]
  // );

  // const onOpenSettingModal = useCallback(() => {
  //   workspaceDialogService.open('setting', {
  //     activeTab: 'appearance',
  //   });
  //   track.$.navigationPanel.$.openSettings();
  // }, [workspaceDialogService]);

  const handleOpenDocs = useCallback(
    (result: {
      docIds: string[];
      entryId?: string;
      isWorkspaceFile?: boolean;
    }) => {
      const { docIds, entryId, isWorkspaceFile } = result;
      // If the imported file is a workspace file, open the entry page.
      if (isWorkspaceFile && entryId) {
        workbench.openDoc(entryId);
      } else if (!docIds.length) {
        return;
      }
      // Open all the docs when there are multiple docs imported.
      // yuanshi注释，默认打开第一个文档
      // if (docIds.length > 1) {
      //   workbench.openAll();
      // } else {
      // Otherwise, open the only doc.
      workbench.openDoc(`${docIds[0]}?refer=other`);
      // }
    },
    [workbench]
  );

  const onOpenImportModal = useCallback(() => {
    track.$.navigationPanel.importModal.open();
    workspaceDialogService.open('import', undefined, payload => {
      if (!payload) {
        return;
      }
      handleOpenDocs(payload);
    });
  }, [workspaceDialogService, handleOpenDocs]);

  return (
    <AppSidebar>
      <SidebarContainer>
        {/* <div className={workspaceAndUserWrapper}>
          <div className={workspaceWrapper}>
            <WorkspaceNavigator
              showEnableCloudButton
              showSyncStatus
              open={workspaceSelectorOpen}
              onOpenChange={onWorkspaceSelectorOpenChange}
              dense
            />
          </div>
        </div> */}
        <div className={quickSearchAndNewPage}>
          <QuickSearchInput
            className={quickSearch}
            data-testid="slider-bar-quick-search-button"
            data-event-props="$.navigationPanel.$.quickSearch"
            onClick={onOpenQuickSearchModal}
          />
          <AddPageButton />
        </div>
        <HomePageButton />
        {/* <AllDocsButton /> */}
        {/* <AppSidebarJournalButton /> */}
        {/* {sessionStatus === 'authenticated' && <NotificationButton />} */}
        {/* <AIChatButton /> */}
        {/* <MenuItem
          data-testid="slider-bar-workspace-setting-button"
          icon={<SettingsIcon />}
          onClick={onOpenSettingModal}
        >
          <span data-testid="settings-modal-trigger">
            {t['com.affine.settingSidebar.title']()}
          </span>
        </MenuItem> */}
      </SidebarContainer>
      <SidebarScrollableContainer>
        {/* <NavigationPanelFavorites /> */}
        <NavigationPanelOrganize />
        {/* <NavigationPanelMigrationFavorites /> */}
        {/* <NavigationPanelTags /> */}
        {/* <NavigationPanelCollections /> */}
        <CollapsibleSection
          name="others"
          title={t['com.affine.rootAppSidebar.others']()}
          contentStyle={{ padding: '6px 8px 0 8px' }}
        >
          <TrashButton />
          <MenuItem
            data-testid="slider-bar-import-button"
            icon={<ImportIcon />}
            onClick={onOpenImportModal}
          >
            <span data-testid="import-modal-trigger">{t['Import']()}</span>
          </MenuItem>
          {/* <InviteMembersButton /> */}
          {/* <TemplateDocEntrance /> */}
          {/* <ExternalMenuLinkItem
            href="https://affine.pro/blog?tag=Release+Note"
            icon={<JournalIcon />}
            label={t['com.affine.app-sidebar.learn-more']()}
          /> */}
        </CollapsibleSection>
      </SidebarScrollableContainer>
      <UserInfo />
      {/* <SidebarContainer className={bottomContainer}>
        <SidebarAudioPlayer />
        {BUILD_CONFIG.isElectron ? <UpdaterButton /> : <AppDownloadButton />}
      </SidebarContainer> */}
    </AppSidebar>
  );
});

RootAppSidebar.displayName = 'memo(RootAppSidebar)';
